<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.city_car_routes") }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        :to="{ name: 'city_routes_create', query: { ...$route.query } }"
        large
        class="primary"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <v-expansion-panels class="mb-8 mt-4" focusable v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t("filter_by")
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container fluid>
            <v-row>
              <v-col cols="12" lg="4" class="mx-0">
                <AutoCompleteFilter
                  :label="$t('fields.car_classification')"
                  :items="car_classifications"
                  item-text="name"
                  item-value="id"
                  filterName="car_classification"
                />
              </v-col>
              <v-col cols="12" lg="4" class="mx-0">
                <AutoCompleteFilter
                  :label="$t('fields.from_city')"
                  :items="from_cities"
                  item-text="name"
                  item-value="id"
                  filterName="from_city"
                />
              </v-col>
              <v-col cols="12" lg="4" class="mx-0">
                <AutoCompleteFilter
                  :label="$t('fields.to_city')"
                  :items="to_cities"
                  item-text="name"
                  item-value="id"
                  filterName="to_city"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="city-car-routes"
      resName="city_car_routes"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">
          {{ item.car_classification && item.car_classification.name }}
        </td>
        <td class="text-sm-center">
          {{ item.from_city && item.from_city.name }}
        </td>
        <td class="text-sm-center">{{ item.to_city && item.to_city.name }}</td>

        <td class="text-center">
          {{ item.price }}
        </td>
        <td class="text-center">
          {{ item.round_trip_price }}
        </td>
        <td class="toggle-spacing text-center">
          {{ item.reserve_before_start_in_hours }}
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="car-classifications"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="city-car-routes"
            :model-id="item.id"
            field="auto_accept_order"
            v-model="item.auto_accept_order"
            :validate="true"
          />
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="city-car-routes"
            :model-id="item.id"
            field="allow_round_trip"
            v-model="item.allow_round_trip"
            :validate="true"
          />
        </td>

        <td class="text-sm-center">
          <v-btn icon color="info" :to="`/car/city-car-routes/edit/${item.id}`">
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "CityCarRoutes",

  data() {
    return {
      panel: 0,
      overlay: false,
      imagePath: "",
      dummyIcon: "https://via.placeholder.com/50x50?text=icon",
      loadingFromCities: true,
      loadingToCities: true,
      from_cities: [],
      to_cities: [],
      car_classifications: [],
      headers: [
        "name",
        "car_classification",
        "from_city",
        "to_city",
        "price",
        "round_trip_price",
        "reserve_before_start_in_hours",
        "visible",
        "auto_accept_order",
        "allow_round_trip",
        "actions"
      ]
    };
  },
  mounted() {
    this.getFromCities();
    this.getToCities();
    this.getCarClassifications();
  },
  methods: {
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },

    async getFromCities() {
      const res = await IndexData({
        reqName: "tourism-cities",
        query: { pagination: "all", has_from_city_routes: true }
      });
      const { tourism_cities } = res.data;
      this.from_cities = tourism_cities;
      this.loadingFromCities = false;
    },
    async getToCities() {
      const res = await IndexData({
        reqName: "tourism-cities",
        query: { pagination: "all", has_to_city_routes: true }
      });
      const { tourism_cities } = res.data;
      this.to_cities = tourism_cities;
      this.loadingToCities = false;
    },

    async getCarClassifications() {
      const res = await IndexData({
        reqName: "car-classifications",
        query: { pagination: "all" }
      });
      const { car_classifications } = res.data;
      this.car_classifications = car_classifications;
    }
  }
};
</script>
